import React, { useCallback } from 'react';
import { useGame } from '../context/GameContext.jsx';

const BottomBar = () => {
  const { 
    translations, 
    lang, 
    qrScannerModalRef, 
    showToastMessage, 
    fetchSessionStatus, 
    currentCards,       
    showAlertModal,     
    verifySolution,
    setIsPollingUpdate
  } = useGame();

  const handleScanClick = useCallback(() => {
    console.log('handleScanClick: Scan button clicked.'); 
    if (qrScannerModalRef.current && qrScannerModalRef.current.bsModal) {
      qrScannerModalRef.current.bsModal.show();
      console.log('handleScanClick: QR Scanner modal displayed.'); 
    } else {
      console.warn('handleScanClick: qrScannerModalRef.current or bsModal not ready.');
    }
  }, [qrScannerModalRef, lang, translations]);

  const handleSolveClick = useCallback(() => {
    console.log('handleSolveClick: Solve button clicked.'); 

    const bookmarkedCardCodes = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith('hypothesis_') && localStorage.getItem(key) === 'true') {
        const cardCode = key.replace('hypothesis_', '');
        bookmarkedCardCodes.push(cardCode);
      }
    }
    console.log(`handleSolveClick: Cards marked as hypothesis (codes): ${bookmarkedCardCodes}`); 

    if (bookmarkedCardCodes.length === 0) {
      console.log('handleSolveClick: No hypothesis card selected.'); 
      showToastMessage(translations[lang]?.no_hypothesis_selected_toast);
      return; 
    }

    const hypothesisCardsDetails = bookmarkedCardCodes.map(code => {
      const card = currentCards.find(c => c.CardId === code);
      return card ? { title: card.Title, cardId: card.CardId } : { title: code, cardId: code };
    });
    console.log('handleSolveClick: Card details for modal:', hypothesisCardsDetails); 

    const confirmationMessage = (
      <>
        <p>{translations[lang]?.confirm_solve_message_prefix}</p>
        <ul className="list-unstyled text-start ms-4">
          {hypothesisCardsDetails.map((card, index) => (
            <li key={index}><strong>{card.title}</strong> ({card.cardId})</li>
          ))}
        </ul>
        <p className="fw-bold mt-3">{translations[lang]?.confirm_solve_message_suffix}</p>
      </>
    );
    console.log('handleSolveClick: Confirmation message prepared.'); 

    showAlertModal(
      translations[lang]?.confirm_solve_title, 
      confirmationMessage, 
      true, 
      () => {
        console.log('handleSolveClick: Solution confirmed: YES. Calling verifySolution.'); 
        verifySolution(bookmarkedCardCodes);
      },
      () => {
        console.log('handleSolveClick: Solution confirmed: NO. Canceled.'); 
        console.log('Solution confirmation canceled.'); 
      },
      translations[lang]?.confirm_solve_yes_button, 
      translations[lang]?.confirm_solve_no_button 
    );
    console.log('handleSolveClick: showAlertModal call completed.'); 
  }, [
    showToastMessage, 
    translations, 
    lang, 
    currentCards, 
    showAlertModal, 
    verifySolution
  ]);

  const handleRefreshClick = useCallback(() => {
    setIsPollingUpdate(false);
    console.log('handleRefreshClick: Refresh button clicked.'); 
    fetchSessionStatus(true); 
  }, [fetchSessionStatus, lang, translations]);

  return (
    <div className="bottom-bar">
      <button className="bottom-bar-button" onClick={handleScanClick} title={translations[lang]?.scan_qr_button}>
        <i className="fas fa-qrcode bottom-bar-icon"></i>
      </button>

      <button className="bottom-bar-button" onClick={handleSolveClick} title={translations[lang]?.solve_button}>
        <i className="fas fa-paper-plane bottom-bar-icon"></i> 
      </button>

      <button className="bottom-bar-button" onClick={handleRefreshClick} title={translations[lang]?.refresh_button}>
        <i className="fas fa-sync-alt bottom-bar-icon"></i>
      </button>
    </div>
  );
};

export default BottomBar;
